import {RequestType, UyapRequest} from "./UyapRequest";

/**
 * PTT servisinden dönen tekil hareket kaydı
 * (TebligatForm içerisinde PttHareket tipi olarak kullanılıyor)
 */
export interface PttHareket {
    aciklama: string;
    durum: number;
    durumSpecified: boolean;
    icon_id: number;
    icon_idSpecified: boolean;
    il: string;
    ilce: string;
    intSaat: number;
    intSaatSpecified: boolean;
    intTarih: number;
    intTarihSpecified: boolean;
    islem_detay: string;
    islem_merkezi: number;
    islem_merkeziSpecified: boolean;
    islem_turu: string;
    isyeri: string;
    mazbata: boolean;
    mazbataSpecified: boolean;
    mazbata_aciklama: string;
    reserve1: string;
    reserve2: string;
    reserve3: string;
    reserve4: string;
    reserve5: string;
    saat: string;
    sicil_no: number;
    sicil_noSpecified: boolean;
    tarih: string;
    teslim_ust_durum: string | null;
    yurtIciMi: number;
    yurtIciMiSpecified: boolean;
}

export interface PttKabul {
    agirlik: string;
    alici: string;
    alici_adres: string;
    barkod_no: string;
    damga_vergisi: string;
    deger_konulmus_bedeli: string;
    desi: string;
    ekhizmetler: string;
    gonderici: string;
    gonderici_adres: string;
    gumruge_sunma_ucreti: string;
    gumruk_vergisi: string;
    kabul_isyeri: string;
    kabul_tarihi: number;
    kabul_tarihiSpecified: boolean;
    odeme_sarti_bedeli: string;
    odeme_tipi: string;
    reserve1: string;
    reserve2: string;
    reserve3: string;
    reserve4: string;
    reserve5: string;
    toplam_yd_ucret: string;
    ucret: string;
    yd_iade_ucreti: string;
}

/**
 * Servisin döndürdüğü son durum bilgisi
 * (TebligatForm içerisinde PttSonDurum tipi olarak kullanılıyor)
 */
export interface PttSonDurum {
    ahk_durum_aciklama: string;
    ahk_teslim_alan: string;
    ahk_teslim_tarihi: string;
    mazb_dosya_no: string;
    mazb_durum_aciklama: string;
    mazb_islem_tarihi: string;
    son_durum_aciklama: string;
    son_islem_saati: string;
    son_islem_tarihi: string;
    sozl_durum_aciklama: string;
    sozl_teslim_alan: string;
    sozl_teslim_tarihi: string;
    teslim_alan: string;
    teslim_durum_aciklama: string;
    teslim_tarihi: string;
}

/**
 * PTT API'sinin ham cevabı
 * (TebligatForm içerisinde PttBarkodResponse tipi olarak kullanılıyor)
 */
export interface PttBarkodResponse {
    almaHaberFlag: boolean;
    almaHaberFlagSpecified: boolean;
    errorMessage: string;
    errorState: boolean;
    errorStateSpecified: boolean;
    hareketDongu: PttHareket[];
    kabul: PttKabul;
    sondurum: PttSonDurum;
}

/**
 * Bot / servis tarafına gönderilecek istek payload'ı
 * Örnek: ["4006994437064"]
 */
export type PttBarkodSorgulaTalep = string[];

export interface PttBarkodSorgulaCevap {
    message: string;
    status: "error" | "success";
    items: Array<{
        tarih: string;
        saat?: string;
        islem: string;
        sube?: string;
        il_ilce?: string;
        aciklama?: string;
        [key: string]: any;
    }>;
    /**
     * Tebligat kayıtlarını güncellemek için kullanılan özet veri
     */
    updateData?: {
        barkodResponse: {
            message: string;
            items: PttHareket[];
            status: "error" | "success";
        };
        tebligat_durumu: "teslim_edildi" | "bila" | null;
        teslim_tarihi: string | null;
        bila_sebebi: string | null;
        bila_tarihi: string | null;
        tebligat_gonderim_tarihi: string | null;
        [key: string]: any;
    };
    /**
     * UI tarafında detay gösterimi için ham PTT cevabı
     */
    rawData?: PttBarkodResponse;
    /**
     * Son durum etiketi (badge vs. için)
     */
    son_durum?: string;
}

export default class PttBarkodSorgula extends UyapRequest<PttBarkodSorgulaTalep, PttBarkodSorgulaCevap> {
    delayTime = 250;

    /** PTT servisine gider (imza.eicrapro.com:6097), UYAP'a değil: engel kapısından muaf. */
    protected engelKapisindenMuaf(): boolean {
        return true;
    }

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "PTT barkod sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 1), //* 1 gun
            key: "barkodptt_" + this.talepData
        };
    }

    getMockResponse(): any {
        const mock: PttBarkodResponse = {
            almaHaberFlag: false,
            almaHaberFlagSpecified: true,
            errorMessage: "BAŞARILI",
            errorState: true,
            errorStateSpecified: true,
            hareketDongu: [
                {
                    aciklama: "KABUL EDİLDİ",
                    durum: 1,
                    durumSpecified: true,
                    icon_id: 1,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "ÇANKAYA",
                    intSaat: 16282313,
                    intSaatSpecified: true,
                    intTarih: 20250220,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 14894,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "MUSTAFA KEMAL",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "ADLİYE İCRALAR",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "16:28:23",
                    sicil_no: 257569,
                    sicil_noSpecified: true,
                    tarih: "20/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İL İÇİ AKTARMADA",
                    durum: 3,
                    durumSpecified: true,
                    icon_id: 3,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "ÇANKAYA",
                    intSaat: 16282320,
                    intSaatSpecified: true,
                    intTarih: 20250220,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 14894,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "MUSTAFA KEMAL",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "ADLİYE İCRALAR",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "16:28:23",
                    sicil_no: 257569,
                    sicil_noSpecified: true,
                    tarih: "20/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İL İÇİ AKTARMADA",
                    durum: 3,
                    durumSpecified: true,
                    icon_id: 3,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "YENİMAHALLE",
                    intSaat: 18395011,
                    intSaatSpecified: true,
                    intTarih: 20250221,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 8789,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "ANKARA PİM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "ANKARA PİM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "18:39:50",
                    sicil_no: 641444,
                    sicil_noSpecified: true,
                    tarih: "21/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İL İÇİ AKTARMADA",
                    durum: 11,
                    durumSpecified: true,
                    icon_id: 3,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "KEÇİÖREN",
                    intSaat: 7191857,
                    intSaatSpecified: true,
                    intTarih: 20250222,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 13961,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "KEÇİÖREN PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "KEÇİÖREN PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "07:19:18",
                    sicil_no: 621261,
                    sicil_noSpecified: true,
                    tarih: "22/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "DAĞITIMDA",
                    durum: 7,
                    durumSpecified: true,
                    icon_id: 4,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "KEÇİÖREN",
                    intSaat: 9584073,
                    intSaatSpecified: true,
                    intTarih: 20250222,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 13961,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "KEÇİÖREN PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "KEÇİÖREN PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "09:58:40",
                    sicil_no: 613889,
                    sicil_noSpecified: true,
                    tarih: "22/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İADE",
                    durum: 151,
                    durumSpecified: true,
                    icon_id: 5,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "KEÇİÖREN",
                    intSaat: 10151138,
                    intSaatSpecified: true,
                    intTarih: 20250224,
                    intTarihSpecified: true,
                    islem_detay: "Tanınmıyor",
                    islem_merkezi: 13961,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "KEÇİÖREN PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "KEÇİÖREN PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "10:15:11",
                    sicil_no: 613889,
                    sicil_noSpecified: true,
                    tarih: "24/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İL İÇİ AKTARMADA",
                    durum: 3,
                    durumSpecified: true,
                    icon_id: 5,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "KEÇİÖREN",
                    intSaat: 11254683,
                    intSaatSpecified: true,
                    intTarih: 20250225,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 13961,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "KEÇİÖREN PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "KEÇİÖREN PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "11:25:46",
                    sicil_no: 621251,
                    sicil_noSpecified: true,
                    tarih: "25/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İL İÇİ AKTARMADA",
                    durum: 44,
                    durumSpecified: true,
                    icon_id: 5,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "YENİMAHALLE",
                    intSaat: 13422583,
                    intSaatSpecified: true,
                    intTarih: 20250226,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 13623,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "YENİMAHALLE PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "YENİMAHALLE PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "13:42:25",
                    sicil_no: 613401,
                    sicil_noSpecified: true,
                    tarih: "26/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "DAĞITIMDA",
                    durum: 7,
                    durumSpecified: true,
                    icon_id: 5,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "YENİMAHALLE",
                    intSaat: 7094210,
                    intSaatSpecified: true,
                    intTarih: 20250227,
                    intTarihSpecified: true,
                    islem_detay: " ",
                    islem_merkezi: 13623,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "YENİMAHALLE PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "YENİMAHALLE PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "07:09:42",
                    sicil_no: 613401,
                    sicil_noSpecified: true,
                    tarih: "27/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                },
                {
                    aciklama: "İADE",
                    durum: 120,
                    durumSpecified: true,
                    icon_id: 5,
                    icon_idSpecified: true,
                    il: "ANKARA",
                    ilce: "YENİMAHALLE",
                    intSaat: 11214205,
                    intSaatSpecified: true,
                    intTarih: 20250227,
                    intTarihSpecified: true,
                    islem_detay: "Göndericisine Teslim Edildi",
                    islem_merkezi: 13623,
                    islem_merkeziSpecified: true,
                    islem_turu: "",
                    isyeri: "YENİMAHALLE PDM",
                    mazbata: false,
                    mazbataSpecified: true,
                    mazbata_aciklama: "",
                    reserve1: "YENİMAHALLE PDM",
                    reserve2: "",
                    reserve3: "",
                    reserve4: "",
                    reserve5: "",
                    saat: "11:21:42",
                    sicil_no: 613401,
                    sicil_noSpecified: true,
                    tarih: "27/02/2025",
                    teslim_ust_durum: null,
                    yurtIciMi: 1,
                    yurtIciMiSpecified: true
                }
            ],
            kabul: {
                agirlik: "20",
                alici: "B**** K*****",
                alici_adres: "Y********* M***",
                barkod_no: "4006994437064",
                damga_vergisi: "",
                deger_konulmus_bedeli: "0.00",
                desi: "0.00",
                ekhizmetler: "",
                gonderici: "A***** 1*",
                gonderici_adres: "",
                gumruge_sunma_ucreti: "",
                gumruk_vergisi: "",
                kabul_isyeri: "MUSTAFA KEMAL",
                kabul_tarihi: 20250220,
                kabul_tarihiSpecified: true,
                odeme_sarti_bedeli: "0.00",
                odeme_tipi: "UM",
                reserve1: "TEBLIGAT/UYAP",
                reserve2: "ANKARA/KEÇİÖREN",
                reserve3: " / ",
                reserve4: "",
                reserve5: "",
                toplam_yd_ucret: "",
                ucret: "210.00",
                yd_iade_ucreti: ""
            },
            sondurum: {
                ahk_durum_aciklama: " ",
                ahk_teslim_alan: " ",
                ahk_teslim_tarihi: "0",
                mazb_dosya_no: " ",
                mazb_durum_aciklama: " ",
                mazb_islem_tarihi: "0",
                son_durum_aciklama: "İADE",
                son_islem_saati: "11214205",
                son_islem_tarihi: "20250227",
                sozl_durum_aciklama: " ",
                sozl_teslim_alan: " ",
                sozl_teslim_tarihi: "0",
                teslim_alan: "",
                teslim_durum_aciklama: " ",
                teslim_tarihi: "0"
            }
        };

        // Gerçek servis bir array döndüğü için mock'u da aynı formatta tutuyoruz
        return [mock];
    }

    getRequestType(): RequestType {
        return "json";
    }

    getUrl(): string {
        return "https://imza.eicrapro.com:6097/api/ShipmentTracking";
    }

    /**
     * Bot / PTT servisine giden payload'ı senkronize eden yardımcı fonksiyon.
     * Farklı çağrı şekillerini tek tipe (string[]) dönüştürür.
     *
     * Örnek kullanım:
     *  - normalizeRequestPayload("4006994437064")      => ["4006994437064"]
     *  - normalizeRequestPayload({ barkodNo: "..." })  => ["..."]
     *  - normalizeRequestPayload({ q: "..." })         => ["..."]
     *  - normalizeRequestPayload(["..."])              => ["..."]
     */
    protected normalizeRequestPayload(requestData: any): PttBarkodSorgulaTalep {
        // Zaten dizi ise, string dizisine normalize et
        if (Array.isArray(requestData)) {
            return requestData
                .map((x) => (x == null ? "" : String(x).trim()))
                .filter((x) => !!x);
        }

        // Nesne şeklinde gelen istekler
        if (requestData && typeof requestData === "object") {
            if (Array.isArray(requestData.barkodNoList)) {
                return requestData.barkodNoList
                    .map((x: any) => (x == null ? "" : String(x).trim()))
                    .filter((x: string) => !!x);
            }

            if (requestData.barkodNo != null) {
                const val = String(requestData.barkodNo).trim();
                return val ? [val] : [];
            }

            if (requestData.q != null) {
                const val = String(requestData.q).trim();
                return val ? [val] : [];
            }
        }

        // String / number vb.
        if (typeof requestData === "string" || typeof requestData === "number") {
            const val = String(requestData).trim();
            return val ? [val] : [];
        }

        return [];
    }

    /**
     * Harici kullanımlar için statik helper.
     * Bot'a giden payload'ı tek noktadan üretmek isteyenler bu fonksiyonu kullanabilir.
     */
    public static buildRequestPayload(source: any): PttBarkodSorgulaTalep {
        const instance = new PttBarkodSorgula();
        return instance.normalizeRequestPayload(source);
    }

    /**
     * Base sınıftaki prepareRequestData fonksiyonunu override ederek
     * farklı çağrı tiplerini yukarıdaki örnek payload ile senkronize ediyoruz.
     */
    async prepareRequestData(requestData: any): Promise<{ data: any; type: "urlencoded" | "formData" | "xml" | "json" }> {
        const normalized = this.normalizeRequestPayload(requestData);
        // imza.eicrapro.com ShipmentTracking servisi PTT ile aynı sözleşmeyi kullanıyor ve
        // gövdede tekil barkod string'i bekliyor (örn: "4007056172589").
        // Dizi gönderilirse backend "The JSON value could not be converted to System.String"
        // hatası verip barkod alanını boş kabul ediyor (HTTP 400).
        const barkod = normalized.length > 0 ? normalized[0] : "";
        return super.prepareRequestData(barkod);
    }

    /**
     * PTT API cevabını parse eder.
     * - JSON cevap (beklenen yeni format)
     * - Geriye dönük uyumluluk için HTML string cevap
     */
    async parse(data: any): Promise<PttBarkodSorgulaCevap> {
        try {
            // JSON formatını bekliyoruz (prepareResponseData.tryForJson sonrası)
            if (Array.isArray(data) || (data && typeof data === "object" && (data as any).hareketDongu)) {
                const raw: PttBarkodResponse = Array.isArray(data) ? (data[0] as PttBarkodResponse) : (data as PttBarkodResponse);

                if (!raw || !Array.isArray(raw.hareketDongu) || raw.hareketDongu.length === 0) {
                    const message = raw?.errorMessage || "PTT servisinden hareket bilgisi alınamadı.";
                    return {
                        message,
                        status: "error",
                        items: []
                    };
                }

                const hareketler: PttHareket[] = raw.hareketDongu;
                const items = hareketler.map((h: PttHareket) => {
                    const ilIlce = [h.il, h.ilce].filter(Boolean).join("/");
                    return {
                        tarih: h.tarih,
                        saat: h.saat,
                        islem: h.aciklama,
                        sube: h.isyeri,
                        il_ilce: ilIlce,
                        aciklama: h.islem_detay,
                        // Ham veriyi de her satırda tutmak isteyenler için referans
                        _raw: h
                    };
                });

                const durumMesaji = raw.sondurum?.son_durum_aciklama || raw.errorMessage || "BAŞARILI";

                // Teslimat ve bila kontrolü
                const teslimBilgisi = items.find(item => item.islem && item.islem.toUpperCase().includes("TESLİM"));
                const bilaBilgisi = items.find(item => item.islem && item.islem.toUpperCase().includes("İADE"));

                // İlk işlem (gönderim tarihi) için
                const ilkIslem = items.length > 0 ? items[0] : null;

                const updateData: PttBarkodSorgulaCevap["updateData"] = {
                    barkodResponse: {
                        message: durumMesaji,
                        items: hareketler,
                        status: "success"
                    },
                    tebligat_durumu: teslimBilgisi ? "teslim_edildi" : (bilaBilgisi ? "bila" : null),
                    teslim_tarihi: teslimBilgisi?.tarih || null,
                    bila_sebebi: bilaBilgisi?.aciklama || null,
                    bila_tarihi: bilaBilgisi?.tarih || null,
                    tebligat_gonderim_tarihi: ilkIslem?.tarih || null
                };

                return {
                    message: durumMesaji,
                    items,
                    status: "success",
                    updateData,
                    rawData: raw,
                    son_durum: durumMesaji
                };
            }

            // Geriye dönük: HTML string parse (eski PTT ekranı)
            if (typeof data === "string") {
                const div = document.createElement("div");
                const items: any[] = [];
                div.innerHTML = data;
                const alert = div.querySelector(".container .alert");

                if (alert) {
                    return {
                        message: alert.innerHTML.replace("\n", "").trim(),
                        items: [],
                        status: "error"
                    };
                }

                // @ts-ignore
                const durumElement = div.querySelector("main .container .row .col-8 h8") as HTMLElement | null;
                const durum = durumElement ? durumElement.innerText : "";
                const list = div.querySelectorAll("#shipmentGroup tbody tr");

                list.forEach(item => {
                    const tds = item.querySelectorAll("td");
                    items.push({
                        tarih: tds[0]?.innerText,
                        islem: tds[1]?.innerText,
                        sube: tds[2]?.innerText,
                        il_ilce: tds[3]?.innerText,
                        aciklama: tds[4]?.innerText
                    });
                });

                const teslimBilgisi = items.find(item => item.islem && item.islem.includes("TESLİM EDİLDİ"));
                const bilaBilgisi = items.find(item => item.islem && item.islem.includes("İADE"));
                const ilkIslem = items.length > 0 ? items[0] : null;

                const updateData: PttBarkodSorgulaCevap["updateData"] = {
                    barkodResponse: {
                        message: durum,
                        items,
                        status: "success"
                    },
                    tebligat_durumu: teslimBilgisi ? "teslim_edildi" : (bilaBilgisi ? "bila" : null),
                    teslim_tarihi: teslimBilgisi?.tarih || null,
                    bila_sebebi: bilaBilgisi?.aciklama || null,
                    bila_tarihi: bilaBilgisi?.tarih || null,
                    tebligat_gonderim_tarihi: ilkIslem?.tarih || null
                };

                return {
                    message: durum,
                    items,
                    status: "success",
                    updateData
                };
            }

            // Beklenmeyen format
            return {
                message: "PTT servisinden beklenmeyen bir cevap alındı.",
                items: [],
                status: "error"
            };
        } catch (error) {
            return {
                message: error instanceof Error ? error.message : "Bir hata oluştu",
                items: [],
                status: "error"
            };
        }
    }
}
